import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

/**
 * SubscriptionPage - Redirects to the new unified pricing/billing pages
 * This page is kept for backward compatibility with old routes
 */
const SubscriptionPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user has a subscription
    const token = localStorage.getItem('auth_token');
    
    if (token) {
      // Logged in user - go to billing page
      navigate('/billing', { replace: true });
    } else {
      // Not logged in - go to pricing page
      navigate('/pricing', { replace: true });
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-blue-600 mx-auto mb-4" />
        <p className="text-slate-600">Redirecting to pricing...</p>
      </div>
    </div>
  );
};

export default SubscriptionPage;
